import {useEffect, useState} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import {Link, useParams} from "react-router-dom";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {CheckIcon, ThinChevronRight, ThinEditIcon, ThinTrashIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {AdminsStaffAnswerRequestModal} from "./answer-request-modal";

export const AdminsStaffRequestDetailsScreen = () => {
    const [data, setData] = useState({
        loaded: false,
        staffId: 0,
        firstName: '',
        lastName: '',
        img: '',
        category: '',
        title: '',
        body: '',
        isAnswered: false,
        answeredAt: '',
        adminName: '',
        adminRole: '',
        isApproved: false,
        createdAt: '',
        answer: '',
        job:'',
    });
    const {requestId} = useParams();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/staff/requests/details',
            {
                id:requestId as string,
            },
            true,
            (d: {
                result: string,
                reason: string,
                staffId: number,
                firstName: string,
                lastName: string,
                img: string,
                category: string,
                title: string,
                body: string,
                isAnswered: boolean,
                answeredAt: string,
                adminName: string,
                adminRole: string,
                isApproved: boolean,
                createdAt: string,
                answer: string,
                job:string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    title: d.title,
                    adminName: d.adminName,
                    adminRole: d.adminRole,
                    answer: d.answer,
                    answeredAt: d.answeredAt,
                    createdAt: d.createdAt,
                    isApproved: d.isApproved,
                    category: d.category,
                    body: d.body,
                    firstName: d.firstName,
                    isAnswered: d.isAnswered,
                    lastName: d.lastName,
                    staffId: d.staffId,
                    img: d.img,
                    loaded: true,
                    job: d.job,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
        document.title = 'مشاهده درخواست | منابع انسانی | اتوماسیون';
    }, []);
    const [answerModal,setAnswerModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {url: '/admins', title: 'اتوماسیون'},
                {url: '/admins/staff', title: 'منابع انسانی'},
                {url: '/admins/staff/requests', title: 'درخواست ها'},
                {url: `/admins/staff/requests/view/${requestId}`, title: data.loaded ? data.title : '...'},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>مشاهده درخواست</b>
                                <button onClick={()=>setAnswerModal(true)}>
                                    <CheckIcon/>
                                    <span>پاسخ به درخواست</span>
                                </button>
                            </div>
                            <div className="row">
                                <div className="col-lg-8 col-md-6">
                                    <div className="student-info">
                                        <span>عنوان:</span>
                                        <b>{data.title}</b>
                                        <span>متن درخواست:</span>
                                        <b>{data.body}</b>
                                        <span>دسته بندی:</span>
                                        <b>{data.category}</b>
                                        <span>تاریخ ثبت درخواست:</span>
                                        <b>{StringDigitsConvertToPersian(data.createdAt.split(' ')[1] + " " + GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                        <span>وضعیت درخواست:</span>
                                        <b>{data.isAnswered ? 'پاسخ داده شده' : 'در انتظار پاسخگویی'}</b>
                                        {
                                            data.isAnswered ?
                                                <>
                                                    <span>وضعیت تایید:</span>
                                                    <b>{data.isApproved ? 'تایید شده' : 'رد شده'}</b>
                                                    <span>تاریخ پاسخ:</span>
                                                    <b>{StringDigitsConvertToPersian(data.answeredAt.split(' ')[1] + " " + GregorianToPersian(data.answeredAt.split(' ')[0]).replaceAll('-', '/'))}</b>
                                                    <span>کاربر پاسخگو:</span>
                                                    <b>{data.adminName} - ({data.adminRole})</b>
                                                    <span>پاسخ داده شده:</span>
                                                    <b>{data.answer}</b>
                                                </> : null
                                        }
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6">
                                <label>درخواست کننده:</label>
                                    <div className="staff-item">
                                        <em style={{backgroundImage: `url(${ServerImage(data.img, 200)})`}}/>
                                        <b>{data.firstName + " " + data.lastName}</b>
                                        <strong data-color={"blue"} style={{backgroundColor:'#eee',color:'#444'}}>
                                            {data.job === '' ? 'بدون شغل' : data.job}
                                        </strong>
                                        <div>
                                            &nbsp;
                                            <Link to={`/admins/staff/view/${data.staffId}`}
                                                  className="staff-item-view">
                                                <span>مشاهده کارمند</span>
                                                <ThinChevronRight/>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            <AdminsStaffAnswerRequestModal
                active={answerModal}
                closeHandler={()=>setAnswerModal(false)}
                requestId={requestId as string}
                onDone={()=>{
                    ShowProgressLoading();
                    fetchData();
                }}
                                           />
        </>
    );
};